import React from "react";
import { FaFilm } from "react-icons/fa";

const AftermoviesLogo = () => <FaFilm color="black" size={"40px"} />;

export default AftermoviesLogo;